import team1 from '../assets/images/team1.jpg'
import team2 from '../assets/images/team2.jpg'
import team3 from '../assets/images/team3.jpg'
import team4 from '../assets/images/team4.jpg'
export const teamData = [
    {
        id: 1,
        image: team1,
        company: "// founder //",
        name: "Rosalina D. William"       
    },
    {
        id: 2,
        image: team2,
        company: "// founder //",
        name: "Rosalina D. William"       
    },
    {
        id: 3,
        image: team3,
        company: "// founder //",
        name: "Rosalina D. William"       
    },
    {
        id: 4,
        image: team4,
        company: "// founder //",
        name: "Rosalina D. William"       
    },
]